import { useEffect, useState } from "react";
import { SwiperSlide } from "swiper/react";
import "./styles.css";

import Constants from "../../../../../constants/Index";
import axios from "../../../../../services/axios";

import { TableVisualizationContainer } from "../CategoryAnimal/VisualizationContainer/Index";
import { TableVisualizationRow } from "../CategoryAnimal/TableVisualizationRow/Index";
import { TitleTable } from "../CategoryAnimal/Title/Index";
import { OnboardingFooterV2 } from "../../../../OnboardingV2/OnboardingFooterV2";
import {
  IAnimalEvolution,
  IAnimalEvolutions,
} from "../../../../../@types/app/AnimalCategory/IEvolution";
import { IEvolutionsOnboarding } from "../../../../../@types/Onboarding/IEvolution";
import { useOnboarding } from "../../../../../hooks/useOnboarding";
import { IAnimalCategory } from "../../../../../@types/app/AnimalCategory/ICategory";
import { OptionV2 } from "../../../../FormControlsV2";

const MONTH_LABELS = Object.values(Constants.MONTHS_FULL_NAME);

interface AnimalCategoryProps {
  onBoarding?: boolean;
  onlyRead?: boolean;
  farmSelected?: OptionV2<number> | null;
}

export function AnimalCategory({
  onlyRead = false,
  onBoarding = false,
  farmSelected = null,
}: AnimalCategoryProps) {
  const { payload, setPayload } = useOnboarding();

  const [evolutionList, setEvolutionList] = useState<IAnimalEvolutions>([]);
  const [maxCategories, setMaxCategories] = useState(0);

  function handleDataObject(data: IAnimalEvolutions, modifications?: IEvolutionsOnboarding) {
    if (!onlyRead) {
      const payloadData = modifications ? modifications : payload?.evolutions;
      const newEvolutions = data.map((evolution) => {
        const newCategory = evolution.categories.map((category) => {
          const monthUpdated = payloadData?.filter((f) => f.category_id === category.id);
          if (monthUpdated && monthUpdated.length > 0) {
            const months = category.month_evolution.map((month) => {
              const founded = monthUpdated.find((f) => f.month === month.month);
              return founded ? { ...month, weight: founded.weight } : month;
            });
            return { ...category, month_evolution: months };
          }
          return category;
        });
        return { ...evolution, categories: newCategory };
      });
      setEvolutionList(() => newEvolutions as IAnimalEvolutions);
    }
  }

  useEffect(() => {
    if (!onBoarding && !farmSelected) return;

    axios.get(onBoarding && !farmSelected ? "/evolutions" : `/evolutions/${farmSelected?.value}`).then(({ data }) => {
      if (data) {
        const categories = new Map<number, IAnimalCategory>();
        data.forEach((evolution: IAnimalEvolution) =>
          evolution.categories.forEach((category) => {
            categories.set(category.id, category);
            const categoryLength = category.month_evolution.length;
            setMaxCategories((count) => (count < categoryLength ? categoryLength : count));
          }),
        );

        if (!onlyRead) {
          setPayload((payload) => {
            const response = { ...payload, categories: categories };
            localStorage.setItem(Constants.LOCALSTORAGE_PAYLOAD, JSON.stringify(response));
            return response;
          });
        } else {
          setEvolutionList(data as IAnimalEvolutions);
        }

        handleDataObject(data);
      }
    });
  }, [onBoarding, farmSelected, onlyRead]);

  return (
    <>
      <main>
        <section className="animalcategory__container">
          <div className="animacategory__content">
            <h1 className="conteudo-title evolution__title">Categoria e Evolução Animal</h1>
            {evolutionList.length > 0 ? (
              evolutionList.map((evolution, key) => (
                <section key={key} className="evolution__container">
                  <TitleTable title={evolution.type} handleClick={() => { }} onlyRead />
                  <TableVisualizationContainer>
                    {MONTH_LABELS.map((_month, monthKey) => {
                      if (maxCategories > monthKey)
                        return (
                          <SwiperSlide key={monthKey}>
                            {evolution.categories.map((category, categoryKey) => {
                              category.month_evolution.sort((a, b) => (a.month < b.month ? -1 : 1));
                              if (category.month_evolution[monthKey])
                                return (
                                  <TableVisualizationRow
                                    key={categoryKey}
                                    category={category}
                                    month={category.month_evolution[monthKey]}
                                  />
                                );
                              return null;
                            })}
                          </SwiperSlide>
                        );
                      return null;
                    })}
                  </TableVisualizationContainer>
                </section>
              ))
            ) : (
              <>
                <br />
                <span>Não há pesos cadastrados para esta Propriedade</span>
              </>
            )}
          </div>
        </section>
      </main>
    </>
  );
}
